import { useEffect, useState } from 'react'
import { FolderSync } from 'lucide-react'
import Button from '../../components/Button'
import { FormBody, InfoNote } from '../../components/Form'
import FormRow from '../../components/FormRow'
import Modal from '../../components/Modal'
import Select from '../../components/Select'
import { strings as S } from './strings'
import './modals.css'

const C = S.clone

/**
 * سحب الإدارات من مصدر الربط — `/Groups/Clone`.
 *
 * The endpoint and its service function have been here since the slice was wired, offered
 * by nothing. It takes one `ActiveDirectoryId`, and the page payload has always carried the
 * list of configured sources — also read by nothing until now.
 *
 * A source has to be CHOSEN rather than assumed: one is the normal case, but the payload
 * returns a list and picking the wrong directory imports the wrong organisation.
 */
export default function GroupCloneModal({ open, sources, onClose, onSubmit, saving }) {
  const [sourceId, setSourceId] = useState('')

  // Preselect when there is only one — the choice is real, but it should not be busywork.
  useEffect(() => {
    if (!open) return
    setSourceId(sources?.length === 1 ? String(sources[0].id) : '')
  }, [open, sources])

  const options = (sources ?? []).map((source) => ({
    value: String(source.id),
    label: source.type ? `${source.name} — ${source.type}` : source.name,
  }))

  return (
    <Modal
      open={open}
      size="sm"
      title={C.title}
      icon={FolderSync}
      hint={C.hint}
      onClose={onClose}
      footer={
        <Button disabled={!sourceId || saving} onClick={() => onSubmit(sourceId)}>
          {saving ? C.running : C.submit}
        </Button>
      }
    >
      <FormBody>
        <FormRow label={C.source}>
          {(id) => (
            <Select
              id={id}
              value={sourceId}
              onChange={setSourceId}
              options={options}
              placeholder={C.sourcePlaceholder}
            />
          )}
        </FormRow>

        {/* It ADDS; it does not mirror. Saying so here is the difference between an
            administrator running it once and running it expecting a two-way sync. */}
        <InfoNote>
          <bdi>{C.note}</bdi>
        </InfoNote>
      </FormBody>
    </Modal>
  )
}
